import {
  process
} from "./chunk-QN6WLX5Z.mjs";
import {
  require_buffer
} from "./chunk-6GGEUYZ7.mjs";
import {
  __toESM
} from "./chunk-BSSMCHER.mjs";

// src/globals.js
var import_buffer = __toESM(require_buffer(), 1);
(() => {
  if (typeof globalThis !== "undefined" && !Object.getOwnPropertyDescriptor(globalThis, "global")) {
    Object.defineProperty(globalThis, "global", {
      value: globalThis,
      configurable: true,
      writable: false,
      enumerable: true
    });
  }
  if (typeof globalThis !== "undefined" && !globalThis.Buffer) {
    globalThis.Buffer = import_buffer.Buffer;
  }
  if (typeof globalThis !== "undefined" && !globalThis.process) {
    globalThis.process = process;
  }
})();
//# sourceMappingURL=chunk-4QUCD27N.mjs.map
